import { createUseStyles } from "react-jss";
import { ITheme } from "../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    boxSizing: "border-box",
    padding: theme.spacing.space24,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gap: theme.spacing.space40,
    maxWidth: 600,
    [theme.mediaQueries.mobile]: {
      gap: theme.spacing.space24,
      width: "100%",
    },
  },
  textBlock: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space16,
    [theme.mediaQueries.mobile]: {
      gap: theme.spacing.space4,
    },
  },
  title: {
    margin: 0,
  },
  description: {
    margin: 0,
  },
  button: {
    minWidth: 160,
  },
}));
